// Email validation rules and utilities
export const EMAIL_RULES = {
  minLength: 5,
  maxLength: 254, // Maximum length per RFC 5321
  allowedDomains: [], // Empty means all domains allowed
  blockedDomains: ['tempmail.com', 'throwaway.com'], // Example disposable email domains
};

export function validateEmailFormat(email: string): boolean {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return emailRegex.test(email);
}

export function validateEmailLength(email: string): boolean {
  return email.length >= EMAIL_RULES.minLength && email.length <= EMAIL_RULES.maxLength;
}

export function validateEmailDomain(email: string): boolean {
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  
  // Block known disposable email domains
  if (EMAIL_RULES.blockedDomains.includes(domain)) {
    return false;
  }
  
  // If allowedDomains is empty, all domains are allowed
  // Otherwise, check against the allowlist
  return EMAIL_RULES.allowedDomains.length === 0 || 
         EMAIL_RULES.allowedDomains.includes(domain);
}

export interface EmailValidationResult {
  isValid: boolean;
  errors: string[];
}

export function validateEmail(email: string): EmailValidationResult {
  const errors: string[] = [];
  
  if (!email) {
    errors.push('Email is required');
    return { isValid: false, errors };
  }

  if (!validateEmailLength(email)) {
    errors.push(`Email must be between ${EMAIL_RULES.minLength} and ${EMAIL_RULES.maxLength} characters`);
  }

  if (!validateEmailFormat(email)) {
    errors.push('Please enter a valid email address');
  }

  if (!validateEmailDomain(email)) {
    errors.push('This email domain is not allowed');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
}